import { ref } from 'vue'
import { messages } from './messages.js'

const STORAGE_KEY = 'othello-locale'
const DEFAULT_LOCALE = 'zh-CN'

export const localeOptions = [
  { code: 'zh-CN', native: '🇨🇳 简体中文' },
  { code: 'zh-TW', native: '🇨🇳 繁體中文' },
  { code: 'en', native: '🇺🇸 English' },
  { code: 'ja', native: '🇯🇵 日本語' },
  { code: 'ko', native: '🇰🇷 한국어' },
  { code: 'fr', native: '🇫🇷 Français' },
  { code: 'de', native: '🇩🇪 Deutsch' },
  { code: 'ru', native: '🇷🇺 Русский' },
  { code: 'es', native: '🇪🇸 Español' }
]

function readStored() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE
  try {
    let v = localStorage.getItem(STORAGE_KEY)
    if (v === 'zh') {
      v = 'zh-CN'
      try {
        localStorage.setItem(STORAGE_KEY, 'zh-CN')
      } catch {
        /* ignore */
      }
    }
    if (v && messages[v]) return v
  } catch {
    /* ignore */
  }
  return DEFAULT_LOCALE
}

export const locale = ref(readStored())

function getNested(obj, path) {
  return path.split('.').reduce((o, k) => (o != null && o[k] !== undefined ? o[k] : undefined), obj)
}

function applyParams(str, params) {
  let s = str
  for (const [k, v] of Object.entries(params)) {
    s = s.split(`{${k}}`).join(String(v))
  }
  return s
}

export function t(path, params = {}) {
  const pack = messages[locale.value] || messages[DEFAULT_LOCALE]
  let s = getNested(pack, path)
  if (s === undefined) {
    s = getNested(messages[DEFAULT_LOCALE], path)
  }
  if (typeof s !== 'string') return path
  return applyParams(s, params)
}

export function setLocale(code) {
  if (!messages[code]) return
  locale.value = code
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(STORAGE_KEY, code)
    } catch {
      /* ignore */
    }
    const htmlLang = code === 'zh-TW' ? 'zh-Hant' : code
    document.documentElement.lang = htmlLang
  }
}

export function useI18n() {
  return { locale, localeOptions, setLocale, t }
}
